import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import { UserLoginMessagesService } from '@core/store/services/user-login-messages.service';
import { ActionTypes } from '@core/store/actions';
import * as actions from '@core/store/actions';
import { of } from 'rxjs';

@Injectable()
export class UserLoginMessagesEffects {
  constructor(private userLoginMessagesService: UserLoginMessagesService, private actions$: Actions) {}

  loadUserLoginMessages$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.LoadUserLoginMessages),
      exhaustMap(action => {
        return this.userLoginMessagesService.getUserLoginMessages().pipe(
          map(messages => new actions.LoadUserLoginMessagesSuccess(messages)),
          catchError(error => of(new actions.LoadUserLoginMessagesFail(error)))
        );
      })
    );
  });

  setLoginMedssageAsRead$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.LoginMessageSetAsRead),
      map((action: actions.LoginMessageSetAsRead) => action.payload),
      exhaustMap(loginMessageId => {
        return this.userLoginMessagesService.setLoginMessageAsRead(loginMessageId).pipe(
          map(result => new actions.LoginMessageSetAsReadSuccess(result)),
          catchError(error => of(new actions.LoginMessageSetAsReadFail(error)))
        );
      })
    );
  });
}
